module.exports = __webpack_public_path__ + "img/case_ams.05999bd8.png";